module.exports = new __parcel__URL__("Design Decision Hover.2b270b62.svg").toString();